function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlineInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.23 8.01 5.18)",
    id: "nXp-HJkGz7VZJhyvNYdZj"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1.19, -1.33)",
    d: "M 1.18652 1.33334 L 1.19319 1.33334",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.23 8.01 8.01)",
    id: "s8VK51TFjXIeJyWtSDyf4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-7.19, -7)",
    d: "M 7.18652 13 C 10.5002 13 13.1865 10.3137 13.1865 7 C 13.1865 3.68629 10.5002 1 7.18652 1 C 3.87281 1 1.18652 3.68629 1.18652 7 C 1.18652 10.3137 3.87281 13 7.18652 13 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.23 0 0 1.23 8.01 9.51)",
    id: "FIjbe-a2CD4qaLy8UZRN2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "currentColor",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "round",
      strokeDashoffset: 0,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-1.19, -2.33)",
    d: "M 0.52002 1 L 1.18669 1 L 1.18669 3.66667 L 1.85335 3.66667",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineInfo);
export default __webpack_public_path__ + "static/media/outline_info.9e45f55db8597f4c25e2e1e935e42b2e.svg";
export { ForwardRef as ReactComponent };